import { useEffect, useRef } from 'react';

export const usePrevious = <T = undefined>(value: T, isInitValue = false): T | null => {
  const ref = useRef<T | null>(isInitValue ? value : null);
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};
